<template>
    <div>

        <q-dialog v-model="dialogNuevo" persistent>
            <q-card>
                <q-card-section class="row items-center q-pb-none">
                    <div class="text-h6">Nuevo Usuario</div>
                    <q-space />
                    <q-btn icon="close" flat round dense v-close-popup />
                </q-card-section>

                <q-card-section class="row items-center">
                    <div class="row q-col-gutter-md">
                        <div class="col-12">
                            <q-input dense outlined v-model="form.nombre" label="Nombre(s)" />
                        </div>
                        <div class="col-12">
                            <q-input dense outlined v-model="form.apellidos" label="Apellidos" />
                        </div>
                        <div class="col-12">
                            <q-input dense outlined v-model="form.email" label="Correo electrónico" type="email" />
                        </div>
                        <div class="col-12">
                            <q-input dense outlined v-model="form.telefono" mask="(###) ### - ####" label="Teléfono" />
                        </div>
                        <div class="col-12">
                            <q-input dense outlined v-model="form.password" label="Contraseña" />
                        </div>
                    </div>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn flat color="red" label="Cerrar" v-close-popup />
                    <q-btn flat label="Guardar" color="primary" @click="guardarDatos()" />
                </q-card-actions>
            </q-card>
        </q-dialog>


        <q-card class="shadow-0">
            <q-card-section class="row justify-between">
                <div class="text-h6">Usuarios <span class="text-subtitle2 text-grey"></span>
                </div>
                <q-btn outline icon="mdi-plus" label="Nuevo" color="primary" class="q-mr-sm" @click="nuevvoUsuario()" />
            </q-card-section>
            <q-separator />
            <q-card-section>
                <div class="row q-col-gutter-md">
                    <div class="col-12">
                        <q-table dense class="shadow-0" :data="dataList" :loading="loading" :columns="columns"
                            color="primary" row-key="_id" :pagination="initialPagination">

                            <template v-slot:body="props">
                                <q-tr :props="props" class="hover-fila">
                                    <q-td key="nombre" :props="props" @click="verItem(props.row)">{{ props.row.nombre
                                        }}</q-td>
                                    <q-td key="apellidos" :props="props" @click="verItem(props.row)">{{
                                        props.row.apellidos
                                        }}</q-td>
                                    <q-td key="telefono" :props="props" @click="verItem(props.row)">{{
                                        props.row.telefono }}</q-td>
                                    <q-td key="email" :props="props" @click="verItem(props.row)">{{ props.row.email
                                        }}</q-td>
                                    <q-td key="fechaCreacion" :props="props" @click="verItem(props.row)">{{
                                        props.row.fechaCreacion }}</q-td>
                                    <q-td key="estatus" :props="props">
                                        <q-badge v-if="props.row.estatus == 'Vigente'" color="green" label="Activo" />
                                        <q-badge v-if="props.row.estatus == 'Eliminado'" color="purple"
                                            label="Inactivo" />
                                    </q-td>
                                </q-tr>
                            </template>
                        </q-table>
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </div>
</template>

<script>
import axios from 'axios'
import { QSpinnerClock } from 'quasar'
import moment from 'moment';

export default {
    name: 'PerfilUsuario',
    data() {
        return {
            form: {
                _id: '',
                nombre: '',
                apellidos: '',
                email: '',
                telefono: '',
                password: '',
                estatus: 'Vigente',
                rol: 'Administrador',
                fechaCreacion: '',
                imagenPerfil: 'https://cdn.quasar.dev/img/boy-avatar.png'
            },
            loading: false,
            dataList: [],
            columns: [
                { name: 'nombre', label: 'Nombre', field: 'nombre', align: 'center', sortable: true },
                { name: 'apellidos', label: 'Apellidos', field: 'apellidos', align: 'center', sortable: true },
                { name: 'telefono', label: 'Télefono', field: 'telefono', align: 'center', sortable: true },
                { name: 'email', label: 'Email', field: 'email', align: 'center', sortable: true },
                { name: 'fechaCreacion', label: 'Fecha', field: 'fechaCreacion', align: 'center', sortable: true },
                { name: 'estatus', label: 'Estatus', field: 'estatus', align: 'center', sortable: true },
            ],
            initialPagination: {
                sortBy: 'nombre',
                descending: false,
                page: 1,
                rowsPerPage: 10
            },
            dialogNuevo: false
        }
    },
    computed: {
        adminStore() {
            return this.$store.state.auth.usuario;
        },
    },
    methods: {
        verItem(item) {
            console.log(item)
        },
        nuevvoUsuario() {
            this.form = {
                _id: '',
                nombre: '',
                apellidos: '',
                email: '',
                telefono: '',
                password: '',
                estatus: 'Vigente',
                rol: 'Administrador',
                fechaCreacion: ''
            }
            this.dialogNuevo = true
        },

        async guardarDatos() {
            console.log(this.form)
            if (this.form.nombre == '' || this.form.apellidos == '' || this.form.password == '' || this.form.email == '') {
                this.$q.notify({ type: 'negative', position: 'top-right', message: 'Ingrese los datos faltantes.' })
                return
            }
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Guardando información. Espere...', messageColor: 'white' })

            this.form.fechaCreacion = moment().format('YYYY/MM/DD')
            try {
                await axios.post('Login/PostRegistroNuevo/', this.form)
                this.$q.loading.hide()

                this.$q.notify({ type: 'positive', position: 'top-right', message: 'Usuario nuevo registrado.' })
                this.dialogNuevo = false
                this.obtenerPerfil()

            } catch (err) {
                console.log(err)
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: err.data })
            }
        },
        async obtenerPerfil() {
            try {
                const res = await axios.get('Configuracion/GetUsuarios/')
                this.dataList = res.data
            } catch (err) {
                console.log(err)
            }
        }
    },
    mounted() {
        this.obtenerPerfil()
    },

}
</script>
<style>
.q-table thead {
    border-color: #0094ca !important;
}
</style>